module.exports = __webpack_public_path__ + "static/media/kkaeda-sagac.39f8ef0f.png";